// removed by extract-text-webpack-plugin
module.exports = {"drag-n-drop":"style__drag-n-drop___2t9pl","drag-n-drop--dragging":"style__drag-n-drop--dragging___1BjhB","drag-n-drop__instruction":"style__drag-n-drop__instruction___Dmeac","drag-n-drop__or":"style__drag-n-drop__or___2dhtz","file-icon":"style__file-icon___3Mgnt","file-list":"style__file-list___3cm5K","remove-file-button":"style__remove-file-button___1ur-X","save-button":"style__save-button___3ybvn","progress-bar":"style__progress-bar___UTsBk"};


//////////////////
// WEBPACK FOOTER
// ./components/ResourcePackForm/style.scss
// module id = 1324
// module chunks = 0